import type { SanityDocument } from '@sanity/client';
import type { ComponentType} from 'react';
import { lazy } from 'react';
import type { DataSanity } from './DataAttributeContext';
import { SanityProjectDetailsContext } from './ImageUrlBuilderContext';
import type { SanityProps } from './getSanityPageProps';
import type { Breadcrumb } from './pageTree';

const SanityLiveMode = lazy(() => import('./SanityLiveMode'));

interface SanityPageComponentProps<T extends SanityDocument> {
    page: T;
    url: URL;
    breadcrumbs: Breadcrumb[];
    dataAttribute?: DataSanity;
}

export type SanityPageComponent<T extends SanityDocument> = ComponentType<SanityPageComponentProps<T>>;

export default function SanityPage<T extends SanityDocument>(Component: SanityPageComponent<T>) {
    return (props: SanityProps<T>) => (
        <SanityProjectDetailsContext value={props.projectDetails}>
            {props.draftMode ? (
                <SanityLiveMode {...props} component={Component as any} />
            ) : (
                <Component page={props.initial.data} url={new URL(props.url)} breadcrumbs={props.breadcrumbs} />
            )}
        </SanityProjectDetailsContext>
    );
}
